function initializeSportxPersonalization(){
 document.querySelectorAll('[data-sx-personalization]').forEach(field=>{
  if(field.dataset.sxReady)return;
  const root=field.closest('.product-form');
  const candidates=[...root.querySelectorAll('[data-option-name]')];
  const hasPersonalization=value=>value.includes('שם')&&value.includes('מספר');
  const picker=candidates.find(el=>hasPersonalization(el.dataset.optionName))||candidates.find(el=>[...el.querySelectorAll('input[type="radio"],option')].some(input=>hasPersonalization(input.value)));
  if(!picker)return;
  field.dataset.sxReady='true';
  const inputs=[...field.querySelectorAll('input,textarea')];
  const update=()=>{
   const selected=picker.querySelector('input:checked')||picker.querySelector('select');
   if(!selected)return;
   const personalized=selected.value.includes('שם')&&selected.value.includes('מספר');
   field.hidden=!personalized;
   inputs.forEach(input=>input.disabled=!personalized);
  };
  picker.addEventListener('change',update);
  root.addEventListener('variant:changed',update);
  update();
 });
}
initializeSportxPersonalization();
document.addEventListener('shopify:section:load',initializeSportxPersonalization);
const purchaseArea=document.querySelector('.sx-purchase-form');
if(purchaseArea){
 new IntersectionObserver(entries=>{
  document.body.classList.toggle('sx-purchase-active',entries.some(entry=>entry.isIntersecting));
 },{threshold:0}).observe(purchaseArea);
}

function initializeSportxReviews(){
 const form=document.querySelector('.sx-purchase-form');
 if(!form)return;
 document.querySelectorAll('.jdgm-cards-carousel').forEach(carousel=>{
  carousel.classList.add('sx-reviews-carousel');
  const rating=carousel.querySelector('.jdgm-average-rating');
  const heading=document.querySelector('h1.product-meta__title');
  if(!rating||!heading||document.querySelector('.sx-review-summary'))return;
  if(!carousel.id)carousel.id='sportx-customer-reviews';
  const link=document.createElement('a');
  link.className='sx-review-summary';
  link.href='#'+carousel.id;
  link.append(rating.cloneNode(true));
  const label=document.createElement('span');
  label.textContent='ביקורות על החנות';
  link.append(label);
  heading.insertAdjacentElement('afterend',link);
 });
}
initializeSportxReviews();
const sportxReviewsObserver=new MutationObserver(initializeSportxReviews);
sportxReviewsObserver.observe(document.querySelector('#main')||document.body,{childList:true,subtree:true});
document.addEventListener('shopify:section:load',initializeSportxReviews);
